import ReturnStripeAccountAdvancedView from './ReturnStripeAccountAdvancedView'

export default ReturnStripeAccountAdvancedView
